import useScrollAnimation from "@/hooks/useScrollAnimation";
import { awardsData } from "@/mocks/homeData";

export default function AwardsSection() {
  const { ref, isVisible } = useScrollAnimation(0.15);

  return (
    <section id="awards" className="w-full py-16 md:py-24 bg-background-50">
      <div
        ref={ref}
        className={`w-full px-4 md:px-6 lg:px-10 transition-all duration-700 ${
          isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"
        }`}
      >
        <div className="text-center max-w-3xl mx-auto mb-10 md:mb-14">
          <span className="text-xs md:text-sm font-semibold text-primary-500 uppercase tracking-widest">
            {awardsData.label}
          </span>
          <h2 className="font-heading font-bold text-xl md:text-3xl lg:text-4xl text-foreground-950 mt-3 mb-4 leading-tight">
            {awardsData.headline}
          </h2>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-3 md:gap-4 max-w-6xl mx-auto">
          {awardsData.awards.map((award) => (
            <div
              key={award.name}
              className="bg-background-100 rounded-xl p-4 md:p-5 border border-background-200/70 hover:border-accent-200 transition-all text-center"
            >
              <div className="w-10 h-10 md:w-11 md:h-11 mx-auto rounded-full bg-accent-50 flex items-center justify-center mb-3">
                <i className="ri-trophy-line text-lg text-accent-500" />
              </div>
              <div className="text-xs font-semibold text-foreground-900 leading-snug mb-1.5">
                {award.name}
              </div>
              <div className="text-xs text-foreground-500 mb-1">
                {award.org}
              </div>
              <div className="text-xs font-medium text-accent-600">
                {award.year}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}